import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Modal} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

import {isSelectStoreOpen} from '../selectors';
import {hideSelectStoreModal} from '../actions';

import customer from '../../customer';
//import labels from '../../labels';
import {clearLabelSheet} from '../../labels/actions';

const {getSubscriptions, getActiveSubscriptionId} = customer.selectors;
const {setActiveSubscription} = customer.actions;

import SelectStoreButton from './SelectStoreButton';

const SelectStoreModal = ({
  actions,
  activeSubscriptionId,
  isOpen,
  subscriptionList
}) => {
  const setActiveSubscription = (subscriptionId) => {
    actions.setActiveSubscription(subscriptionId);
    actions.clearLabelSheet();
    actions.hideSelectStoreModal();
  };

  const oddRowStores = subscriptionList.map((subscription, index) => {
    if(index % 2 === 0) {
      return <SelectStoreButton key={index} subscription={subscription} active={activeSubscriptionId === subscription.id} onClick={setActiveSubscription}/>;
    }
  });

  const evenRowStores = subscriptionList.map((subscription, index) => {
    if(index % 2 !== 0) {
      return <SelectStoreButton key={index} subscription={subscription} active={activeSubscriptionId === subscription.id} onClick={setActiveSubscription}/>;
    }
  });

  return (
		<Modal isOpen={isOpen} toggle={actions.hideSelectStoreModal} id="modalSelectStore">
      <div className="modal-header">
        <h4 className="modal-title" id="exampleModalLabel">{I18n.t('SELECT_STORE')}</h4>
        <button type="button" className="close" onClick={actions.hideSelectStoreModal}>
          <span className="lnr lnr-cross" aria-hidden="true" />
        </button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-sm-6">
            {oddRowStores}
          </div>
          <div className="col-sm-6">
            {evenRowStores}
          </div>
        </div>
      </div>
    </Modal>
	);
};

function mapStateToProps(state) {
  return {
    activeSubscriptionId: getActiveSubscriptionId(state),
    isOpen: isSelectStoreOpen(state),
    subscriptionList: getSubscriptions(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({hideSelectStoreModal, setActiveSubscription, clearLabelSheet}, dispatch)
  };
}

SelectStoreModal.propTypes = {
  actions: PropTypes.object.isRequired,
  activeSubscriptionId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  subscriptionList: PropTypes.array.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectStoreModal);


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/SelectStoreModal.js
 **/